import { doKeycloakLogout as keycloakLogout } from './keycloak';

/**
 * Log out the current user
 */
export const logOut = async () => {
  try {
    // Use Keycloak for logout
    await keycloakLogout();
    return true;
  } catch (error) {
    throw error;
  }
};

/**
 * Log out from Keycloak - keeping this for backward compatibility
 */
export const doKeycloakLogout = async () => {
  try {
    await keycloakLogout();
    return true;
  } catch (error) {
    throw error;
  }
}; 